import React from 'react';
import { Alert, Box } from '@mui/material';

const ErrorAlert = ({ error }) => {
    if (!error) return null;
    return (
        <Box mb={2}>
            <Alert severity="error">
                {error.response?.data?.message || error.message || "An error occurred"}
            </Alert>
        </Box>
    );
};

export default ErrorAlert;
